module.exports = __webpack_public_path__ + "static/media/robofriends.b555dedb.png";